import React, { useContext, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import productData from "../Datas/productData";
import Footer from "./Footer";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";
import Header from "./Header";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);
  const [quantity, setQuantity] = useState(1);
  const [selectedSize, setSelectedSize] = useState(
    product?.size ? product.size[0] : ""
  );
  const [selectedImage, setSelectedImage] = useState(0);
  const [detailsOpen, setDetailsOpen] = useState(true);
  const [deliveryOpen, setDeliveryOpen] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);

  if (!product) {
    return <div>Product not found</div>;
  }

  const handleAddToCart = () => {
    if (product.size && product.size.length > 0 && !selectedSize) {
      alert("Please select a size.");
      return;
    }
    addToCart(product.id, quantity, selectedSize);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <body className="color-scheme color-scheme--scheme-1">
      <Header />

      <main className="product-detail-page">
        <div className="product-detail-container">
          {/* Left Side - Product Images */}
          <div className="product-image-section">
            <div className="main-image">
              <img
                src={product.images[selectedImage]}
                alt={product.name}
                className="product-main-image"
              />
              <button className="zoom-button">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M11 8V14M8 11H14"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
            </div>
            {product.images.length > 1 && (
              <div className="thumbnail-images">
                {product.images.map((img, index) => (
                  <img
                    key={index}
                    src={img}
                    alt={`${product.name} ${index + 1}`}
                    className={`thumbnail ${
                      selectedImage === index ? "active" : ""
                    }`}
                    onClick={() => setSelectedImage(index)}
                  />
                ))}
              </div>
            )}
          </div>

          {/* Right Side - Product Info */}
          <div className="product-info-section">
            <h1 className="product-name">{product.name}</h1>
            <p className="product-price">HK${product.price}</p>

            {/* Color Swatches (if multiple images) */}
            {product.images.length > 1 && (
              <div className="color-selection">
                <div className="color-swatches">
                  {product.images.map((img, index) => (
                    <button
                      key={index}
                      className={`color-swatch ${
                        selectedImage === index ? "active" : ""
                      }`}
                      onClick={() => setSelectedImage(index)}
                    >
                      <img src={img} alt={`Color ${index + 1}`} />
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Size Selection */}
            <div className="size-selection">
              <div className="size-header">
                <label>SIZE GUIDE</label>
              </div>
              <div className="sizes">
                {product.size.map((size) => (
                  <button
                    key={size}
                    className={`size-btn ${
                      selectedSize === size ? "selected" : ""
                    }`}
                    onClick={() => setSelectedSize(size)}
                  >
                    {size}
                  </button>
                ))}
              </div>
            </div>

            {/* Add to Bag Button */}
            <button className="add-to-cart-btn" onClick={handleAddToCart}>
              ADD TO BAG
            </button>

            {/* Bookmark Icon */}
            <button className="bookmark-btn">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M5 21V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21L12 17.5L5 21Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
              </svg>
            </button>

            {/* Details & Care */}
            <div className="accordion-section">
              <button
                className="accordion-header"
                onClick={() => setDetailsOpen(!detailsOpen)}
              >
                <span>DETAILS & CARE</span>
                <span className={`accordion-icon ${detailsOpen ? "open" : ""}`}>
                  {detailsOpen ? "−" : "+"}
                </span>
              </button>
              {detailsOpen && (
                <div className="accordion-content">
                  <p className="product-intro">{product.description[0]}</p>
                  <ul className="product-features">
                    {product.Features.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            {/* Delivery & Returns */}
            <div className="accordion-section">
              <button
                className="accordion-header"
                onClick={() => setDeliveryOpen(!deliveryOpen)}
              >
                <span>DELIVERY & RETURNS</span>
                <span
                  className={`accordion-icon ${deliveryOpen ? "open" : ""}`}
                >
                  {deliveryOpen ? "−" : "+"}
                </span>
              </button>
              {deliveryOpen && (
                <div className="accordion-content">
                  <p>
                    <strong>Delivery:</strong> Standard delivery takes 3-5
                    working days. Express delivery available at checkout.
                  </p>
                  <p>
                    <strong>Returns:</strong> We offer free returns within 30
                    days of purchase. Items must be unworn and in original
                    condition.
                  </p>
                </div>
              )}
            </div>

            {/* Share */}
            <div className="accordion-section">
              <button
                className="accordion-header"
                onClick={() => setShareOpen(!shareOpen)}
              >
                <span>SHARE</span>
                <span className={`accordion-icon ${shareOpen ? "open" : ""}`}>
                  {shareOpen ? "−" : "+"}
                </span>
              </button>
              {shareOpen && (
                <div className="accordion-content">
                  <div className="share-buttons">
                    <button className="share-btn">Facebook</button>
                    <button className="share-btn">Twitter</button>
                    <button className="share-btn">Pinterest</button>
                    <button className="share-btn">Email</button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </body>
  );
};

export default ProductDetail;
